// @mui
import { enUS, frFR, esES, zhCN } from "@mui/material/locale";

// PLEASE REMOVE `LOCAL STORAGE` WHEN YOU CHANGE SETTINGS.
// ----------------------------------------------------------------------

export const allLangs = [
    {
        label: "English",
        value: "en",
        long: "English",
        systemValue: enUS,
        icon: "flagpack:gb-nir",
    },
    {
        label: "Français",
        value: "fr",
        long: "French",
        systemValue: frFR,
        icon: "flagpack:fr",
    },
    {
        label: "Español",
        value: "es",
        long: "Spanish",
        systemValue: esES,
        icon: "flagpack:es",
    },
    {
        label: "中文",
        value: "zh",
        long: "Chinese",
        systemValue: zhCN,
        icon: "flagpack:cn",
    },
];

export const defaultLang = allLangs[0]; // English

// GET MORE COUNTRY FLAGS
// https://icon-sets.iconify.design/flagpack/
// https://www.dropbox.com/sh/nec1vwswr9lqbh9/AAB9ufC8iccxvtWi3rzZvndLa?dl=0
